import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

function renderLabelEditor(props: PropertyEditorProps) {
  const { control, onConfigChange, onBasicChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Label Settings</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Content
          <textarea
            value={(control.config?.content as string) || (control.label ?? '')}
            onChange={(e) => {
              onConfigChange('content', e.target.value || undefined);
              onBasicChange('label', e.target.value);
            }}
            className="af-properties-tab__input af-properties-tab__textarea"
            placeholder="Label text"
            rows={3}
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Font Size
          <select
            value={(control.config?.fontSize as string) || 'md'}
            onChange={(e) => onConfigChange('fontSize', e.target.value)}
            className="af-properties-tab__select"
          >
            <option value="sm">Small</option>
            <option value="md">Medium</option>
            <option value="lg">Large</option>
            <option value="xl">Extra Large</option>
          </select>
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Font Weight
          <select
            value={(control.config?.fontWeight as string) || 'normal'}
            onChange={(e) => onConfigChange('fontWeight', e.target.value)}
            className="af-properties-tab__select"
          >
            <option value="normal">Normal</option>
            <option value="bold">Bold</option>
          </select>
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Alignment
          <select
            value={(control.config?.alignment as string) || 'left'}
            onChange={(e) => onConfigChange('alignment', e.target.value)}
            className="af-properties-tab__select"
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Color
          <input
            type="color"
            value={(control.config?.color as string) || '#000000'}
            onChange={(e) => onConfigChange('color', e.target.value)}
            className="af-properties-tab__input"
            style={{ height: '36px' }}
          />
        </label>
      </div>
    </div>
  );
}

export const LabelEditor: PropertyEditor = {
  type: 'label',
  label: 'Label',
  description: 'Configure label content, font size, weight, alignment, and color',
  render: renderLabelEditor,
};
